var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flickity',{key:_vm.keyIncrementer,ref:"flickity",staticClass:"carousel",class:{ 'carousel--active': _vm.active },attrs:{"options":_vm.computedOptions}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }